<h1 mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>Partnerinfo</h1>
<button class="btn-close btn-icon" mat-dialog-close title="Luk dialog">
  <mat-icon class="material-icons">close</mat-icon>
</button>

<div mat-dialog-content>
  <p>{{ data.name }}</p>
  <p>
    @if (data?.name !== data?.g4Name) {
      <span>
        G4 navn: {{ data.g4Name }}
        <br />
      </span>
    }
    <span>
      Partnernr.: {{ data.partnerNo }}
      <br />
    </span>
    @if (data?.phone) {
      <span>
        T: {{ $safeNavigationMigration(data?.phone) | dkPhoneNumber }}
        <br />
      </span>
    }
    <a href="mailto:{{ data?.email }}" class="ellipsis" title="Send mail til {{ data?.email }}">{{ data?.email }}</a>
  </p>
</div>

<div mat-dialog-actions class="row-reverse">
  <button mat-raised-button color="primary" mat-dialog-close>Luk</button>
</div>
